import React from 'react';
import AboutMe from '../AboutMe';

export default function About() {
  return (
    <>
      <AboutMe />
    </>
  );
}
